import { DataRequirements } from '../data.requirements';
import * as i0 from "@angular/core";
import * as i1 from "../data.requirements";
export class SetLocalStorageUseCase {
    constructor(data) {
        this.data = data;
    }
    run(key, value) {
        return this.data.setLocalStorage(key, value);
    }
}
SetLocalStorageUseCase.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SetLocalStorageUseCase_Factory() { return new SetLocalStorageUseCase(i0.ɵɵinject(i1.DataRequirementsInjectionToken)); }, token: SetLocalStorageUseCase, providedIn: "root" });
